// extracted by mini-css-extract-plugin
export default {"root":"VMStartTable_root__+E2rz"};